import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import image from "../../assets/svg/vendor_logo.svg";
import back from "../../assets/svg/backArrow.svg";
import doc from "../../assets/svg/doc.svg";
import loc from "../../assets/svg/location.svg";
import discuss from "../../assets/svg/discuss.svg";
import edit from "../../assets/svg/edit.svg";
import email_line from "../../assets/svg/mail_line.svg";
import mail from "../../assets/svg/mail.svg";
import phone_line from "../../assets/svg/phone_line.svg";
import phone from "../../assets/svg/phone.svg";
import received from "../../assets/svg/received.svg";
import tick from "../../assets/svg/tick.svg";
import tickGreen from "../../assets/svg/tick_green.svg";
import wrongRed from "../../assets/svg/wrong_red.svg";
import requestImg from "../../assets/svg/request_img.svg";
import createdImg from "../../assets/svg/created_img.svg";
import threedot from "../../assets/svg/threeDotMenu.svg";
import handshake from "../../assets/svg/handshake.svg";
import profileIc from "../../assets/png/profile-ic.png";
import NewIc from "../../assets/png/new_ic.png";
import productDefaultIc from "../../assets/png/product_default.png";
import {
  Row,
  Col,
  Button,
  Nav,
  Spinner,
  Toast,
  ToastContainer,
  Dropdown,
} from "react-bootstrap";
import "../common/Util.css";
import {
  deleteVendorApi,
  getProductListApi,
  getProjectListApi,
  getVendorDetailsApi,
  getVendorStagesApi,
  updateStageApi,
  updateStatusApi,
} from "./vendor_api";
import "./vendorView.css";
import { Sidebar } from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import { ReactComponent as ThreeDotIC } from "../../assets/svg/three-dot-ic.svg";
import { ReactComponent as ProjectIcs } from "../../assets/svg/product_ics.svg";
import { ReactComponent as DwownArrowIc } from "../../assets/svg/downArrow_csd.svg";
import { ReactComponent as DownArrowClIc } from "../../assets/svg/downArrowColor.svg";
import { ReactComponent as DownArrow } from "../../assets/svg/down_arrow_ics.svg";
import { ReactComponent as EditIcon } from "../../assets/svg/edit_ico.svg";
import DeleteModal from "../common/deleteModel";
import { useGlobal } from "../../GlobalContext";
import numberFormat from "../common/number-format.js";
import { FiSearch, FiPlus, FiCalendar } from "react-icons/fi";
import { Calendar } from "lucide-react";
import SelectRangeButton from "../common/select-range-button.jsx";
import BankTaxModal from "./bank-save-model.jsx";
import ContactTab from "./ContactTab.jsx";
import ProductTab from "./ProductTab.jsx";
import {
  getVendorBankDetApi,
  getVendorGSTAttApi,
  getVendorMsmeAttApi,
  getVendorTaxDeApi,
} from "./vendor-api.js";
import RequestTab from "./RequestTab.jsx";
import QuotationTab from "./QuotationTab.jsx";
import PurchaseOrderTab from "./PurchaseOrderTab.jsx";
import HistoryTab from "./history-tab.jsx";
import Activities from "./activities-tab.jsx";
import ProfileImageModal from "../common/common-preview.jsx";
import CommonTooltip from "../common/common_tooltip.jsx";

function VendorViewPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [deleteId, setDeleteId] = useState(null);
  const [dateRange, setDateRange] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [vendorId, setVendorId] = useState(location.state?.id || "");
  const [vendor, setVendor] = useState(null);
  const [vendorBank, setVendorBank] = useState(null);
  const [vendorTax, setVendorTax] = useState(null);
  const [vendorGstAttachemnt, setVendorGstAttachemnt] = useState(null);
  const [vendorMSMEAttachemnt, setVendorMSMEAttachemnt] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const [addressBarAnimated, setAddressBarAnimated] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const [expanded, setExpanded] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isOpenBank, setIsOpenBank] = useState(false);
  const [isBankType, setIsBankType] = useState("");
  const [stageOption, setStageOption] = useState([]);
  const [stageSelect, setStageSelect] = useState(null);
  const statusOption = [
    { value: true, label: "Active" },
    { value: false, label: "In-Active" },
  ];

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);
  const openFile = (fileUrl = "") => {
    if (!fileUrl) return;

    const cleanUrl = fileUrl.split("?")[0].toLowerCase();

    // 🖼 Images → popup
    if (
      cleanUrl.endsWith(".png") ||
      cleanUrl.endsWith(".jpg") ||
      cleanUrl.endsWith(".jpeg") ||
      cleanUrl.endsWith(".gif") ||
      cleanUrl.endsWith(".webp")
    ) {
      setSelectedProfile(fileUrl);
      setShowProfilePopup(true);
      return;
    }

    // 📄 PDF → open directly in browser
    if (cleanUrl.endsWith(".pdf")) {
      setSelectedProfile(fileUrl);
      setShowProfilePopup(true);
      return;
    }

    // 📊 Office files → Office Viewer
    if (
      cleanUrl.endsWith(".xls") ||
      cleanUrl.endsWith(".xlsx") ||
      cleanUrl.endsWith(".doc") ||
      cleanUrl.endsWith(".docx") ||
      cleanUrl.endsWith(".ppt") ||
      cleanUrl.endsWith(".pptx")
    ) {
      const officeViewerUrl =
        "https://view.officeapps.live.com/op/view.aspx?src=" +
        encodeURIComponent(fileUrl);

      window.open(officeViewerUrl, "_blank", "noopener,noreferrer");
      return;
    }

    // ⬇ Default → download / open
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };
  const [statusSelect, setStatusSelect] = useState(null);
  const shouldShowTick = (stepName) => {
    const currentStageIndex = stageOrder.indexOf(vendor?.stage);
    const stepIndex = stageOrder.indexOf(stepName);
    return stepIndex <= currentStageIndex;
  };
  const { rolePermissionList, userType } = useGlobal();
  const getFileNameFromUrl = (url) => {
    if (!url || typeof url !== "string") return "";
    return decodeURIComponent(url.split("/").pop().split("?")[0]);
  };
  const getFileExtensionFromUrl = (url) => {
    if (!url || typeof url !== "string") return "";
    const fileName = decodeURIComponent(url.split("/").pop().split("?")[0]);
    return fileName.includes(".")
      ? fileName.split(".").pop().toLowerCase()
      : "";
  };

  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true,
    ) > -1
      ? true
      : false;
  }
  useEffect(() => {
    if (snackbarMessage) {
      setShowSnackbar(true);
    }
  }, [snackbarMessage]);
  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  const [activeTab, setActiveTab] = useState("details");

  const getVendor = async () => {
    setIsLoading(true);
    try {
      const response = await getVendorDetailsApi(vendorId);
      if (response.data.success === true) {
        const fetchedVendor = response.data.vendor;
        setVendor(fetchedVendor);
        setStageSelect({
          value: fetchedVendor.stage_id,
          label: fetchedVendor.stage,
        });
        setStatusSelect({
          value: fetchedVendor.status,
          label: fetchedVendor.status === true ? "Active" : "In-Active",
        });

        isCheckSet(fetchedVendor);

        console.log("Vendor details:", fetchedVendor);
      }
    } catch (err) {
      console.error("Error fetching vendor:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const getVendorBankDet = async () => {
    setIsLoading(true);
    try {
      const response = await getVendorBankDetApi(vendorId);
      if (response.data.success === true) {
        const fetchedVendor = response.data.details;
        console.log({ fetchedVendor });
        setVendorBank(fetchedVendor);
      }
    } catch (err) {
      console.error("Error fetching vendor:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const getVendorTaxDet = async () => {
    setIsLoading(true);
    try {
      const response = await getVendorTaxDeApi(vendorId);
      if (response.data.success === true) {
        const fetchedVendor = response.data.details;
        console.log({ fetchedVendor });
        setVendorTax(fetchedVendor);
      }
    } catch (err) {
      console.error("Error fetching vendor:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const getVendorGstAttach = async () => {
    setIsLoading(true);
    try {
      const response = await getVendorGSTAttApi(vendorId);
      if (response.data.success === true) {
        const fetchedVendor = response.data.attachments;
        console.log({ fetchedVendor });
        setVendorGstAttachemnt(fetchedVendor);
      }
    } catch (err) {
      console.error("Error fetching vendor:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const getVendorMSMEAttch = async () => {
    setIsLoading(true);
    try {
      const response = await getVendorMsmeAttApi(vendorId);
      if (response.data.success === true) {
        const fetchedVendor = response.data.attachments;
        console.log({ fetchedVendor });
        setVendorMSMEAttachemnt(fetchedVendor);
      }
    } catch (err) {
      console.error("Error fetching vendor:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const [projectList, setProjectList] = useState([]);
  const [productsList, setProductsList] = useState([]);

  const getStatusList = async () => {
    try {
      setIsLoading(true);
      const response = await getVendorStagesApi();

      if (response.data.success === true) {
        setStageOption(response.data.suggestionlist ?? []);
        console.log(
          "response.data.suggestionlist",
          response.data.suggestionlist,
        );
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const getProjectList = async () => {
    setIsLoading(true);
    try {
      const params = {
        vendor_id: vendorId,
      };
      const response = await getProjectListApi(params);
      if (response.data.success === true) {
        const fetchedProject = response.data.projects;
        setProjectList(fetchedProject);
      }
    } catch (err) {
      console.error("Error fetching vendor:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const getProductList = async (id) => {
    try {
      const params = {
        vendor_id: vendorId,
        project_id: id,
      };
      const response = await getProductListApi(params);
      if (response.data.success === true) {
        const fetchedProducts = response.data.products;
        setProductsList(fetchedProducts);
      }
    } catch (err) {
      console.error("Error fetching vendor:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const isCheckSet = (vendorData) => {
    const currentStageIndex = stageOrder.indexOf(vendorData?.stage);

    const updatedSteps = stepsState.map((step) => ({
      ...step,
      completed: stageOrder.indexOf(step.name) <= currentStageIndex,
      isCheck: stageOrder.indexOf(step.name) <= currentStageIndex,
    }));

    setStepsState(updatedSteps);
  };

  useEffect(() => {
    if (vendorId) {
      getVendor();
      getVendorBankDet();
      getVendorTaxDet();
      getProjectList();
      getVendorGstAttach();
      getVendorMSMEAttch();
    }
  }, [vendorId]);
  useEffect(() => {
    getStatusList();
  }, []);

  useEffect(() => {
    setTimeout(() => setAddressBarAnimated(true), 200);
  }, []);

  const stageOrder = [
    "New",
    "Initial",
    "Product-Finalize",
    "Documentation",
    "Onboarding",
  ];

  useEffect(() => {
    if (vendor?.stage) {
      const currentStageIndex = stageOrder.indexOf(vendor.stage);

      const updatedSteps = stepsState.map((step) => ({
        ...step,
        completed: stageOrder.indexOf(step.name) <= currentStageIndex,
      }));

      setStepsState(updatedSteps);
    }
  }, [vendor?.stage]);
  const [stepsState, setStepsState] = useState([
    { name: "New", completed: false, isCheck: false },
    { name: "Initial", completed: false, isCheck: false },
    { name: "Product-Finalize", completed: false, isCheck: false },
    { name: "Documentation", completed: false, isCheck: false },
    { name: "Onboarding", completed: false, isCheck: false },
  ]);

  const [activeStep, setActiveStep] = useState(0);

  const toggleStep = (index) => {
    const clickedStep = stepsState[index];

    if (clickedStep.isCheck) return;

    const updatedSteps = stepsState.map((step, i) => {
      if (step.isCheck) return step;

      return { ...step, completed: i <= index };
    });

    setStepsState(updatedSteps);
    setActiveStep(index);
  };

  const updateVendorStage = async (id, value) => {
    setIsUpdating(true);
    const bodyData = {
      stage_id: value,
    };
    try {
      const response = await updateStageApi(id, bodyData);

      if (response?.data?.success) {
        setSnackbarMessage(response?.data?.message || "");
        setSnackbarStatus(true);
        await getVendor();
      } else {
        setSnackbarMessage(response?.data?.message || "");
        setSnackbarStatus(false);
      }
    } catch (error) {
      console.error("Error updating vendor status:", error);
      setSnackbarMessage(error?.response?.data?.message || "");
      setSnackbarStatus(false);
    } finally {
      setIsUpdating(false);
    }
  };

  const updateVendorStatus = async (id, option) => {
    setIsUpdating(true);
    const bodyData = {
      status: option.value,
    };
    try {
      const response = await updateStatusApi(id, bodyData);

      if (response?.data?.success) {
        setSnackbarMessage(response?.data?.message || "");
        setSnackbarStatus(true);
        setStatusSelect(option);
        await getVendor();
      } else {
        setSnackbarMessage(response?.data?.message || "");
        setSnackbarStatus(false);
      }
    } catch (error) {
      console.error("Error updating vendor status:", error);
      setSnackbarMessage(error?.response?.data?.message || "");
      setSnackbarStatus(false);
    } finally {
      setIsUpdating(false);
    }
  };

  useEffect(() => {
    if (vendor?.stage) {
      const idx = stepsState.findIndex((step) => step.name === vendor.stage);
      if (idx !== -1) {
        setActiveStep(idx);
        setStepsState(
          stepsState.map((step, i) =>
            i <= idx
              ? { ...step, completed: true }
              : { ...step, completed: false },
          ),
        );
      }
    }
  }, [vendor?.stage]);

  const styles = {
    stepperContainer: {
      backgroundColor: "#F8F8F8",
      borderRadius: "8px",
      padding: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      margin: "20px auto",
    },
    stepItem: {
      textAlign: "center",
      position: "relative",
      flexGrow: 1,
      minWidth: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      cursor: "pointer",
      zIndex: 1,
    },
    iconCircle: (isCompleted) => ({
      width: "45px",
      height: "45px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: isCompleted ? "1.6px solid #4EBD7E" : "1.6px solid #D4DDE7",
      backgroundColor: "#FFFFFF",
      marginBottom: "8px",
      position: "relative",
      zIndex: 1,
      fontSize: "20px",
      boxSizing: "content-box",
    }),
    stepName: (isCompleted) => ({
      color: isCompleted ? "#4EBD7E" : "#515159",
      fontWeight: isCompleted ? "600" : "500",
      fontSize: "14px",
    }),
    connector: (isCompleted, isActive) => ({
      flexGrow: 1,
      height: "2px",
      border: isCompleted
        ? "1.6px dashed #4EBD7E"
        : isActive
          ? "1.6px solid #4F46E5"
          : "1.6px dashed #D4DDE7",
      position: "absolute",
      top: "25px",
      left: "calc(-50% + 20.5px)",
      right: "calc(50% + 22.5px)",
      transition: "border 0.5s",
    }),
    updateButton: {
      backgroundColor: "#4EBD7E",
      border: "none",
      color: "#ffffff",
      padding: "10px 20px",
      borderRadius: "20px",
      fontWeight: "600",
      marginLeft: "30px",
    },
    iconContent: {
      width: "70%",
      height: "70%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "transparent",
      fontSize: "18px",
    },
  };

  const navItemStyle = (isActive) => ({
    padding: "6px 12px",
    marginRight: "6px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "500",
    cursor: "pointer",
    color: isActive ? "#FFFFFF" : "#212129",
    backgroundColor: isActive ? "#4F46E5" : "transparent",
    border: isActive ? "1px solid #4F46E5" : "1px solid #EBEBEB",
    boxShadow: isActive ? "none" : "none",
  });

  const detailLabelStyle = {
    marginBottom: "2px",
    color: "#8790A1",
    fontSize: "14px",
    fontWeight: "500",
  };

  const detailValueStyle = {
    color: "#212129",
    fontSize: "15px",
    fontWeight: "600",
    marginBottom: "2px",
  };

  const stageValueStyle = {
    ...detailValueStyle,
    color: "#4EBD7E",
  };

  const emailStyle = {
    color: "#3875FB",
    textDecoration: "none",
    fontWeight: "600",
  };

  const contactInfoStyle = {
    display: "flex",
    alignItems: "center",
    gap: "5px",
  };

  const barAnimated = {
    border: "4px solid #4F46E5",
    transition: "border 1s cubic-bezier(0.4, 0, 0.2, 1)",
  };
  const barInitial = {
    border: "4px dashed #E5E5E5",
    transition: "border 1s cubic-bezier(0.4, 0, 0.2, 1)",
  };

  const tabs = [
    { key: "details", label: "Details" },
    { key: "bank", label: "Bank & Tax Info" },
    { key: "contacts", label: "Contacts" },
    { key: "product", label: "Product" },
    { key: "request", label: "Request" },
    { key: "quotation", label: "Quotation" },
    { key: "po", label: "Purchase Order" },
    { key: "activity", label: "Activity" },
    { key: "history", label: "History" },
    // { key: "approval_history", label: "Approval History" },
  ];
  const deleteVendor = async () => {
    try {
      const response = await deleteVendorApi(deleteId);
      console.log("response....", response);
      if (response.data.success === true) {
        navigate(-1);
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        setDeleteId(null);
        setIsOpenDelete(false);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseModal = (savedData = null) => {
    if (savedData !== null) {
      getVendor();
      getVendorBankDet();
      getVendorTaxDet();
      getProjectList();
      getVendorGstAttach();
      getVendorMSMEAttch();
      setSnackbarMessage(savedData?.data?.message);
      setSnackbarStatus(savedData?.data?.success);
      handleSnackbarShow();
    }
    setIsOpenBank(false);
  };
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");
  return (
    <>
      <ProfileImageModal
        show={showProfilePopup}
        onClose={() => setShowProfilePopup(false)}
        imageUrl={selectedProfile || ""}
      />
      {isOpenBank && (
        <BankTaxModal
          type={isBankType}
          id={vendorId}
          onClose={() => setIsOpenBank(false)}
          onSuccess={handleCloseModal}
        />
      )}
      <DeleteModal
        title={"vendor"}
        isOpen={isOpenDelete}
        onClose={() => setIsOpenDelete(false)}
        onDelete={deleteVendor}
      />
      <div>
        {/* TOP */}
        <div className="d-flex w-100">
          <Sidebar currentfile="Vendors" />
          <div className="flex-grow-1" style={{ minWidth: 0 }}>
            <Navbar pageTitle="Vendors" />
            <div
              style={{
                flex: 1,

                maxWidth: "100%",
                overflow: "hidden",
              }}
            >
              {" "}
              <div style={{ padding: "20px" }}>
                <Row
                  style={{ alignItems: "center", padding: 0 }}
                  className="d-flex"
                >
                  <Col xs="auto">
                    <img
                      src={back}
                      alt=""
                      style={{
                        padding: 10,
                        width: 40,
                        height: 40,
                        border: "2px solid #EBEBEB",
                        borderRadius: "50%",
                        cursor: "pointer",
                      }}
                      onClick={() => navigate("/vendor")}
                    />{" "}
                  </Col>
                  <Col xs="auto">
                    <div className="profile-wrapper">
                      <img
                        src={
                          vendor?.image && vendor?.image.trim() !== ""
                            ? vendor?.image
                            : profileIc
                        }
                        alt="Profile"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          openFile(
                            vendor.image && vendor.image.trim() !== ""
                              ? vendor.image
                              : profileIc,
                          );
                        }}
                        className="profile-img"
                      />
                      <div className="profile-badge fs-11">
                        {vendor?.grade_name ?? "-"}
                      </div>
                    </div>
                  </Col>
                  <Col>
                    <h5 style={{ margin: 0, color: "#212129" }}>
                      {vendor?.company_name ?? "-"}
                    </h5>
                    <div style={{ color: "#64748B", fontSize: 14 }}>
                      {" "}
                      <img
                        src={loc}
                        alt=""
                        srcset=""
                        style={{ height: 16, width: 16 }}
                      />{" "}
                      {vendor?.billing_city ?? "-"} ·{" "}
                      <span
                        style={{
                          padding: "8px",
                          color: "#097BED",
                          fontWeight: 500,
                          backgroundColor: "#EEF5FF",
                          borderRadius: "16px",
                        }}
                        className="fs-12"
                      >
                        {vendor?.industry ?? "-"}
                      </span>
                    </div>
                  </Col>
                  <Col xs="auto" className="d-flex justify-content-end gap-2">
                    <div onClick={(e) => e.stopPropagation()}>
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="light"
                          id="dropdown-sort"
                          className="d-flex align-items-center justify-content-between rounded-5"
                          style={{
                            border: "1px solid #EBEBEB",
                            backgroundColor: "white",
                            padding: "6px 12px",
                          }}
                        >
                          <span className="d-flex align-items-center px-1 gap-2">
                            <span className="dropdown-text textcolor fs-13 fw-500">
                              {!statusSelect?.label ||
                                statusSelect.label === "-"
                                ? "Update Status"
                                : statusSelect.label}
                            </span>

                            <span className="dropdown-toggle-arrow mb-1">
                              <DownArrow />
                            </span>
                          </span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            border: "1px solid #EBEBEB",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          {statusOption.map((option) => (
                            <Dropdown.Item
                              className="fs-14 fw-500 textcolor"
                              key={option.value}
                              onClick={() => {
                                updateVendorStatus(vendorId, option);
                              }}
                              active={statusSelect?.value === option.value}
                            >
                              {option.label}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div onClick={(e) => e.stopPropagation()}>
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="light"
                          id="dropdown-sort"
                          className="d-flex align-items-center justify-content-between rounded-5"
                          style={{
                            border: "1px solid #EBEBEB",
                            backgroundColor: "white",
                            padding: "6px 12px",
                          }}
                        >
                          <span className="d-flex align-items-center px-1 gap-2">
                            <span className="dropdown-text textcolor fs-13 fw-500">
                              {!stageSelect?.label || stageSelect.label === "-"
                                ? "Update Stage"
                                : stageSelect.label}
                            </span>

                            <span className="dropdown-toggle-arrow mb-1">
                              <DownArrow />
                            </span>
                          </span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            border: "1px solid #EBEBEB",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          {stageOption.map((option) => (
                            <Dropdown.Item
                              className="fs-14 fw-500 textcolor"
                              key={option.value}
                              onClick={() => {
                                updateVendorStage(vendorId, option.value);
                                setStageSelect(option);
                              }}
                              active={stageSelect?.value === option.value}
                            >
                              {option.label}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div onClick={(e) => e.stopPropagation()}>
                      {checkPermission("Vendors", "edit_permission") ||
                        checkPermission(
                          "Vendors",
                          "delete_permission",
                        )(
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="light"
                              id="dropdown-sort"
                              className="d-flex align-items-center justify-content-between  rounded-5 bg-white"
                              style={{
                                width: "36px",
                                height: "36px",
                                border: "1px solid #EBEBEB",
                              }}
                            >
                              <span className="d-flex align-items-center px-1 gap-2">
                                <ThreeDotIC />
                              </span>
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                              style={{
                                backgroundColor: "white",
                                borderRadius: "8px",
                                border: "1px solid #EBEBEB",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                              }}
                            >
                              {checkPermission(
                                "Vendors",
                                "edit_permission",
                              ) && (
                                  <Dropdown.Item
                                    className="fs-14 fw-500 textcolor"
                                    onClick={() => {
                                      navigate("/vendor/create", {
                                        state: { id: vendor.id },
                                      });
                                    }}
                                  >
                                    Edit
                                  </Dropdown.Item>
                                )}
                              {checkPermission(
                                "Vendors",
                                "delete_permission",
                              ) && (
                                  <Dropdown.Item
                                    className="fs-14 fw-500 textcolor"
                                    onClick={() => {
                                      setDeleteId(vendor.id);
                                    }}
                                  >
                                    Delete
                                  </Dropdown.Item>
                                )}
                            </Dropdown.Menu>
                          </Dropdown>,
                        )}
                    </div>
                    <div onClick={(e) => e.stopPropagation()}>
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="light"
                          id="dropdown-sort"
                          className="d-flex align-items-center justify-content-between  rounded-5 bg-white"
                          style={{
                            width: "36px",
                            height: "36px",
                            border: "1px solid #EBEBEB",
                          }}
                        >
                          <span className="d-flex align-items-center px-1 gap-2">
                            <ThreeDotIC />
                          </span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            border: "1px solid #EBEBEB",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            onClick={() => {
                              navigate("/vendor/create", {
                                state: { id: vendor.id },
                              });
                            }}
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            onClick={() => {
                              setDeleteId(vendor.id);
                            }}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </Col>
                  <Row
                    style={{ color: "#555", fontSize: 14 }}
                    className="d-flex align-items-center mt-3"
                  >
                    <Col xs="auto" className="d-flex align-items-center">
                      <img
                        src={mail}
                        alt=""
                        style={{ width: 16, height: 16, marginRight: 5 }}
                      />
                      <div>{vendor?.email ?? "-"}</div>
                    </Col>
                    <Col xs="auto" className="d-flex align-items-center">
                      <img
                        src={phone}
                        alt=""
                        style={{ width: 16, height: 16, marginRight: 5 }}
                      />
                      <div>{vendor?.phone ?? "-"}</div>
                    </Col>
                  </Row>
                </Row>
              </div>
              {/* CONTENT */}
              <div
                style={{
                  backgroundColor: "#F8F8F8",
                  marginTop: 10,
                  padding: 15,
                  borderRadius: 10,
                }}
              >
                <div
                  style={{
                    padding: 20,
                    backgroundColor: "#FFFFFF",
                    borderRadius: 10,
                  }}
                >
                  {/* NAVIGATION ALWAYS SHOW */}
                  <div
                    style={{
                      fontWeight: "600",
                      marginBottom: 10,
                      color: "#212129",
                    }}
                    className="fs-18"
                  >
                    <Nav
                      style={{
                        marginBottom: "16px",
                        gap: "4px",
                        display: "flex",
                        justifyContent: "start",
                        flexWrap: "nowrap",
                        overflowX: "auto",
                        overflowY: "hidden",
                        whiteSpace: "nowrap",
                        scrollbarWidth: "thin",
                      }}
                    >
                      {tabs.map((tab) => (
                        <Button
                          key={tab.key}
                          style={navItemStyle(activeTab === tab.key)}
                          onClick={() => setActiveTab(tab.key)}
                        >
                          {tab.label}
                        </Button>
                      ))}
                    </Nav>

                    {/* Loading Spinner */}
                    {isLoading && (
                      <div style={{ textAlign: "center", margin: "30px 0" }}>
                        <Spinner animation="border" variant="primary" />
                      </div>
                    )}

                    {/* TAB CONTENT */}
                    {!isLoading && activeTab === "details" && (
                      <Row className="justify-content-center">
                        <Col md={5}>
                          <div
                            style={{
                              padding: "0px",
                              backgroundColor: "#FFFFFF",
                              borderRadius: "8px",
                              paddingBottom: 0,
                            }}
                          >
                            <h5
                              style={{
                                fontWeight: "600",
                                marginBottom: "20px",
                                color: "#343a40",
                              }}
                            >
                              Vendor details
                            </h5>
                            <Row className="mb-2">
                              <Col sm={4} style={detailLabelStyle}>
                                Company Name
                              </Col>
                              <Col sm={8} style={detailValueStyle}>
                                {vendor?.company_name ?? "Unknown Company"}
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col sm={4} style={detailLabelStyle}>
                                Stage
                              </Col>
                              <Col sm={8} style={stageValueStyle}>
                                {vendor?.stage ?? "-"}
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col sm={4} style={detailLabelStyle}>
                                Phone
                              </Col>
                              <Col
                                sm={8}
                                style={{
                                  ...detailValueStyle,
                                  ...contactInfoStyle,
                                }}
                              >
                                <img
                                  src={phone_line}
                                  style={{ color: "#007bff", width: "14px" }}
                                />
                                <span>{vendor?.phone ?? "-"}</span>
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col sm={4} style={detailLabelStyle}>
                                Email
                              </Col>
                              <Col
                                sm={8}
                                style={{
                                  ...detailValueStyle,
                                  ...contactInfoStyle,
                                }}
                              >
                                <img
                                  src={email_line}
                                  style={{ color: "#007bff", width: "14px" }}
                                />
                                <div style={emailStyle}>
                                  {vendor?.email ?? "-"}
                                </div>
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col sm={4} style={detailLabelStyle}>
                                Industry
                              </Col>
                              <Col sm={8} style={detailValueStyle}>
                                {vendor?.industry ?? "-"}
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col sm={4} style={detailLabelStyle}>
                                Sub Industry
                              </Col>
                              <Col sm={8} style={detailValueStyle}>
                                {vendor?.sub_industry ?? "-"}
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col sm={4} style={detailLabelStyle}>
                                Grade
                              </Col>
                              <Col sm={8} style={detailValueStyle}>
                                {vendor?.grade_name ?? "-"}
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col sm={4} style={detailLabelStyle}>
                                Code
                              </Col>
                              <Col sm={8} style={detailValueStyle}>
                                {vendor?.code ?? "-"}
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col sm={4} style={detailLabelStyle}>
                                Category
                              </Col>
                              <Col sm={8} style={detailValueStyle}>
                                {vendor?.category ?? "-"}
                              </Col>
                            </Row>
                          </div>
                        </Col>
                        <Col md="auto" className="d-flex align-items-stretch">
                          <div
                            style={{
                              borderLeft: "1px solid #EBEBEB",
                              margin: "0 20px",
                            }}
                          />
                        </Col>
                        <Col md={6}>
                          <div
                            style={{
                              padding: "20px",
                              backgroundColor: "#FFFFFF",
                              borderRadius: "16px",
                              border: "1px solid #EBEBEB",
                            }}
                          >
                            <h5
                              style={{
                                fontWeight: "600",
                                marginBottom: "40px",
                                color: "#343a40",
                              }}
                            >
                              Address information
                            </h5>
                            <div
                              style={{
                                margin: "10px 0 20px 0",
                                position: "relative",
                                height: "24px",
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "0",
                                  width: "100%",
                                  height: "8px",
                                  background: "#E5E5E5",
                                  borderRadius: "4px",
                                  transform: "translateY(-50%)",
                                }}
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "0",
                                  height: "8px",
                                  background: "#4F46E5",
                                  borderRadius: "4px",
                                  width: addressBarAnimated ? "100%" : "0%",
                                  transition:
                                    "width 1s cubic-bezier(0.4, 0, 0.2, 1)",
                                  transform: "translateY(-50%)",
                                  zIndex: 1,
                                }}
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "0",
                                  width: "24px",
                                  height: "24px",
                                  border: "6px solid #DEE8FF",
                                  borderRadius: "50%",
                                  backgroundColor: "#4F46E5",
                                  transform: "translate(-50%, -50%)",
                                  zIndex: 2,
                                }}
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "100%",
                                  width: "24px",
                                  height: "24px",
                                  border: "6px solid #DEE8FF",
                                  borderRadius: "50%",
                                  backgroundColor: "#4F46E5",
                                  transform: "translate(-50%, -50%)",
                                  zIndex: 2,
                                }}
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: "10px",
                                flexWrap: "wrap",
                              }}
                            >
                              <div
                                style={{
                                  textAlign: "left",
                                  flex: 1,
                                  paddingRight: "10px",
                                  wordWrap: "break-word",
                                  overflowWrap: "break-word",
                                  minWidth: 0,
                                }}
                              >
                                <div
                                  style={{
                                    ...detailLabelStyle,
                                    color: "#8790A1",
                                    fontWeight: "bold",
                                  }}
                                >
                                  SHIPPING ADDRESS
                                </div>
                                <div
                                  style={{
                                    ...detailValueStyle,
                                    fontWeight: "normal",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {vendor?.shipping_address ?? "-"}
                                </div>
                              </div>

                              <div
                                style={{
                                  textAlign: "right",
                                  flex: 1,
                                  paddingLeft: "10px",
                                  wordWrap: "break-word",
                                  overflowWrap: "break-word",
                                  minWidth: 0,
                                }}
                              >
                                <div
                                  style={{
                                    ...detailLabelStyle,
                                    color: "#8790A1",
                                    fontWeight: "bold",
                                  }}
                                >
                                  BILLING ADDRESS
                                </div>
                                <div
                                  style={{
                                    ...detailValueStyle,
                                    fontWeight: "normal",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {vendor?.billing_address ?? "-"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    )}
                    {!isLoading && activeTab === "contacts" && (
                      <ContactTab
                        vendorId={vendorId}
                        onShowSnackbar={(message, status) => {
                          setSnackbarMessage(message);
                          setSnackbarStatus(status);
                          handleSnackbarShow();
                        }}
                      />
                    )}
                    {!isLoading && activeTab === "product" && (
                      <ProductTab
                        vendorId={vendorId}
                        vendorName={vendor?.vendor_name}
                        onShowSnackbar={(message, status) => {
                          setSnackbarMessage(message);
                          setSnackbarStatus(status);
                          handleSnackbarShow();
                        }}
                      />
                    )}
                    {!isLoading && activeTab === "request" && (
                      <RequestTab
                        vendorId={vendorId}
                        vendorName={vendor?.vendor_name}
                      />
                    )}
                    {!isLoading && activeTab === "quotation" && (
                      <QuotationTab
                        vendorId={vendorId}
                        vendorName={vendor?.vendor_name}
                        onShowSnackbar={(message, status) => {
                          setSnackbarMessage(message);
                          setSnackbarStatus(status);
                          handleSnackbarShow();
                        }}
                      />
                    )}
                    {!isLoading && activeTab === "po" && (
                      <PurchaseOrderTab
                        vendorId={vendorId}
                        vendorName={vendor?.vendor_name}
                        onShowSnackbar={(message, status) => {
                          setSnackbarMessage(message);
                          setSnackbarStatus(status);
                          handleSnackbarShow();
                        }}
                      />
                    )}
                    {!isLoading && activeTab === "bank" && (
                      <div className="vendor-card">
                        <div className="vendor-grid">
                          {/* Bank Details */}
                          <div
                            style={{
                              borderRight: "1px solid #EBEBEB",
                            }}
                          >
                            <div className="section-header">
                              <span>Bank details</span>
                              <span
                                className="edit-icon"
                                onClick={() => {
                                  setIsBankType("Bank");
                                  setIsOpenBank(true);
                                }}
                              >
                                <EditIcon />
                              </span>
                            </div>

                            <div className="info-row">
                              <span className="label">Bank Name</span>
                              <span className="value">
                                {vendorBank?.bank_name || "-"}
                              </span>
                            </div>

                            <div className="info-row">
                              <span className="label">Holder Name</span>
                              <span className="value">
                                {vendorBank?.holder_name || "-"}
                              </span>
                            </div>

                            <div className="info-row">
                              <span className="label">Bank Acc No</span>
                              <span className="value">
                                {vendorBank?.bank_account_number || "-"}
                              </span>
                            </div>

                            <div className="info-row">
                              <span className="label">IFSC Code</span>
                              <span className="value">
                                {vendorBank?.ifsc_code || "-"}
                              </span>
                            </div>

                            <div className="info-row">
                              <span className="label">Currency</span>
                              <span className="value">
                                {vendorBank?.currency || "-"}
                              </span>
                            </div>
                          </div>

                          {/* <div className="divider" /> */}
                          {/* Tax Info */}
                          <div>
                            <div className="section-header">
                              <span>Tax Info</span>
                              <span
                                className="edit-icon"
                                onClick={() => {
                                  setIsBankType("Tax");
                                  setIsOpenBank(true);
                                }}
                              >
                                <EditIcon />
                              </span>
                            </div>

                            <div className="info-row">
                              <span className="label">Tax Country</span>
                              <span className="value">
                                {vendorTax?.tax_country || "-"}
                              </span>
                            </div>

                            <div className="info-row">
                              <span className="label">Tax Type</span>
                              <span className="value">
                                {vendorTax?.tax_type || "-"}
                              </span>
                            </div>

                            <div className="info-row">
                              <span className="label">GST Number</span>
                              <span className="value">
                                {vendorTax?.tax_number || "-"}
                              </span>
                            </div>
                            <div className="info-row">
                              <span className="label">MSME Number</span>
                              <span className="value">
                                {vendorTax?.msme_number || "-"}
                              </span>
                            </div>

                            <div className="info-row">
                              <span className="label">PAN</span>
                              <span className="value">
                                {vendorTax?.pan_number || "-"}
                              </span>
                            </div>

                            <div className="info-row">
                              <span className="label">VAT Number</span>
                              <span className="value">
                                {vendorTax?.vat_number || "-"}
                              </span>
                            </div>

                            <div className="info-row">
                              <span className="label">TAN Number</span>
                              <span className="value">
                                {vendorTax?.tan_number || "-"}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="divider" />

                        {/* Attachments */}
                        <div className="section-header">
                          <span>Attachments</span>
                          <span
                            className="edit-icon"
                            onClick={() => {
                              setIsBankType("Attach");
                              setIsOpenBank(true);
                            }}
                          >
                            <EditIcon />
                          </span>
                        </div>
                        <div className="row g-3 mt-3">
                          {/* GST Document */}
                          {Array.isArray(vendorGstAttachemnt) &&
                            vendorGstAttachemnt.length > 0 && (
                              <div className="col-md-6">
                                <p className="doc-title">GST Document</p>

                                {vendorGstAttachemnt.map((doc, index) => (
                                  <div
                                    className="doc-card mb-2"
                                    key={doc.id || index}
                                    style={{ cursor: "pointer", overflow: "hidden", maxWidth: "100%" }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      openFile(
                                        doc.file && doc.file.trim() !== ""
                                          ? doc.file
                                          : profileIc,
                                      );
                                    }}
                                  >
                                    <div className="doc-left" style={{ maxWidth: "100%", overflow: "hidden" }}>
                                      <div className="pdf-badge">
                                        {getFileExtensionFromUrl(
                                          doc.file_name,
                                        ).toUpperCase()}
                                      </div>

                                      <div style={{ flex: 1, minWidth: 0 }}>
                                        <CommonTooltip
                                          text={doc.file_name ?? getFileNameFromUrl(doc.file)}
                                          placement="top"
                                          ellipsis={true}
                                          className="doc-name"
                                          id={`gst-tooltip-${index}`}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}

                          {Array.isArray(vendorMSMEAttachemnt) &&
                            vendorMSMEAttachemnt.length > 0 && (
                              <div className="col-md-6">
                                <p className="doc-title">MSME Document</p>

                                {vendorMSMEAttachemnt.map((doc, index) => (
                                  <div
                                    className="doc-card mb-2"
                                    key={doc.id || index}
                                    style={{ cursor: "pointer", overflow: "hidden", maxWidth: "100%" }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      openFile(
                                        doc.file && doc.file.trim() !== ""
                                          ? doc.file
                                          : profileIc,
                                      );
                                    }}
                                  >
                                    <div className="doc-left" style={{ maxWidth: "100%", overflow: "hidden" }}>
                                      <div className="pdf-badge">
                                        {getFileExtensionFromUrl(
                                          doc.file_name,
                                        ).toUpperCase()}
                                      </div>

                                      <div style={{ flex: 1, minWidth: 0 }}>
                                        <CommonTooltip
                                          text={doc.file_name ?? getFileNameFromUrl(doc.file)}
                                          placement="top"
                                          ellipsis={true}
                                          className="doc-name"
                                          id={`msme-tooltip-${index}`}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}

                          {/* MSME Document */}
                          {/* {vendorMSMEAttachemnt && (
                            <div className="col-md-6">
                              <p className="doc-title">MSME Document</p>

                              <div className="doc-card">
                                <div className="doc-left">
                                  <div className="pdf-badge">PDF</div>

                                  <div>
                                    <div className="doc-name">
                                      {vendorMSMEAttachemnt.name}
                                    </div>
                                    <div className="doc-size">
                                      {(
                                        vendorMSMEAttachemnt.size /
                                        1024 /
                                        1024
                                      ).toFixed(2)}{" "}
                                      MB
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )} */}
                        </div>
                      </div>
                    )}
                    {!isLoading && activeTab === "activity" && (
                      <Activities vendorId={vendorId} />
                    )}
                    {!isLoading && activeTab === "history" && (
                      <HistoryTab
                        vendorId={vendorId}
                        vendorName={vendor?.vendor_name}
                      />
                    )}
                    {!isLoading && activeTab === "approval_history" && (
                      <div className="p-4 bg-white rounded-3 mt-3" style={{ minHeight: "200px" }}>
                        <div className="position-relative ps-1">
                          {/* Vertical Dotted Line */}
                          <div
                            style={{
                              position: "absolute",
                              left: "15px",
                              top: "16px",
                              bottom: "16px",
                              width: "2px",
                              borderLeft: "2px dashed #D1D5DB",
                              zIndex: 0
                            }}
                          ></div>

                          {/* Timeline Node 1: Sasi Kumar (Waiting for approval...) */}
                          <div className="d-flex align-items-start position-relative mb-4" style={{ zIndex: 1 }}>
                            <div className="me-3" style={{ zIndex: 2, marginTop: "6px" }}>
                              <img src={tickGreen} alt="waiting" style={{ width: "32px", height: "32px" }} />
                            </div>
                            <div className="d-flex flex-column gap-1">
                              <div className="d-flex align-items-center gap-2">
                                <span
                                  style={{
                                    fontFamily: "'Lexend Deca', sans-serif",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    backgroundColor: "#E5E7EB",
                                    color: "#374151",
                                    padding: "2px 8px",
                                    borderRadius: "4px"
                                  }}
                                >
                                  Sasi Kumar
                                </span>
                              </div>
                              <span className="fst-italic" style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "13px", color: "#4B5563" }}>
                                Waiting for approval...
                              </span>
                              <span style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "12px", color: "#9CA3AF" }}>
                                --:--
                              </span>
                            </div>
                          </div>

                          {/* Timeline Node 2: Sathish Kumar (Rejected) */}
                          <div className="d-flex align-items-start position-relative mb-4" style={{ zIndex: 1 }}>
                            <div className="me-3" style={{ zIndex: 2, marginTop: "6px" }}>
                              <img src={wrongRed} alt="rejected" style={{ width: "32px", height: "32px" }} />
                            </div>
                            <div className="d-flex flex-column gap-1">
                              <div className="d-flex align-items-center gap-2">
                                <span className="fw-600" style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "14px", color: "#1F2937" }}>
                                  Rejected
                                </span>
                                <span style={{ color: "#9CA3AF" }}>·</span>
                                <span
                                  style={{
                                    fontFamily: "'Lexend Deca', sans-serif",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    backgroundColor: "#DBEAFE",
                                    color: "#2563EB",
                                    padding: "2px 8px",
                                    borderRadius: "4px"
                                  }}
                                >
                                  Sathish Kumar
                                </span>
                              </div>
                              <span style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "13px", color: "#4B5563" }}>
                                I'm not satisfied with this PO.
                              </span>
                              <span style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "12px", color: "#9CA3AF" }}>
                                May 23, 2023 at 05:30 PM
                              </span>
                            </div>
                          </div>

                          {/* Timeline Node 3: Madan Kumar (Approved) */}
                          <div className="d-flex align-items-start position-relative mb-4" style={{ zIndex: 1 }}>
                            <div className="me-3" style={{ zIndex: 2, marginTop: "6px" }}>
                              <img src={tickGreen} alt="approved" style={{ width: "32px", height: "32px" }} />
                            </div>
                            <div className="d-flex flex-column gap-1">
                              <div className="d-flex align-items-center gap-2">
                                <span className="fw-600" style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "14px", color: "#1F2937" }}>
                                  Approved
                                </span>
                                <span style={{ color: "#9CA3AF" }}>·</span>
                                <span
                                  style={{
                                    fontFamily: "'Lexend Deca', sans-serif",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    backgroundColor: "#DBEAFE",
                                    color: "#2563EB",
                                    padding: "2px 8px",
                                    borderRadius: "4px"
                                  }}
                                >
                                  Madan Kumar
                                </span>
                              </div>
                              <span style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "13px", color: "#4B5563" }}>
                                I'm satisfied with this purchase order information.
                              </span>
                              <span style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "12px", color: "#9CA3AF" }}>
                                May 23, 2023 at 05:30 PM
                              </span>
                            </div>
                          </div>

                          {/* Timeline Node 4: Requested */}
                          <div className="d-flex align-items-start position-relative mb-4" style={{ zIndex: 1 }}>
                            <div className="me-3" style={{ zIndex: 2, marginTop: "6px" }}>
                              <img src={requestImg} alt="requested" style={{ width: "32px", height: "32px" }} />
                            </div>
                            <div className="d-flex flex-column gap-1">
                              <div className="d-flex align-items-center gap-2">
                                <span className="fw-600" style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "14px", color: "#1F2937" }}>
                                  Requested
                                </span>
                                <span style={{ color: "#9CA3AF" }}>·</span>
                                <span
                                  style={{
                                    fontFamily: "'Lexend Deca', sans-serif",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    backgroundColor: "#DBEAFE",
                                    color: "#2563EB",
                                    padding: "2px 8px",
                                    borderRadius: "4px"
                                  }}
                                >
                                  You
                                </span>
                              </div>
                              <span style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "12px", color: "#9CA3AF" }}>
                                May 23, 2023 at 05:30 PM
                              </span>
                            </div>
                          </div>

                          {/* Timeline Node 5: Created */}
                          <div className="d-flex align-items-start position-relative" style={{ zIndex: 1 }}>
                            <div className="me-3" style={{ zIndex: 2, marginTop: "6px" }}>
                              <img src={createdImg} alt="created" style={{ width: "32px", height: "32px" }} />
                            </div>
                            <div className="d-flex flex-column gap-1">
                              <div className="d-flex align-items-center gap-2">
                                <span className="fw-600" style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "14px", color: "#1F2937" }}>
                                  Created
                                </span>
                                <span style={{ color: "#9CA3AF" }}>·</span>
                                <span
                                  style={{
                                    fontFamily: "'Lexend Deca', sans-serif",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    backgroundColor: "#DBEAFE",
                                    color: "#2563EB",
                                    padding: "2px 8px",
                                    borderRadius: "4px"
                                  }}
                                >
                                  You
                                </span>
                              </div>
                              <span style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "12px", color: "#9CA3AF" }}>
                                May 23, 2023 at 04:30 PM
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="fs-16 fw-600 textcolor mt-3 mb-3">Projects</div>
                {projectList.map((project, index) => (
                  <div
                    style={{
                      backgroundColor: "#FFFFFF",
                      borderRadius: "16px",
                      marginBottom: "16px",
                      overflow: "hidden",
                    }}
                  >
                    {/* Header */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "18px 20px",
                        alignItems: "center",
                      }}
                    >
                      {/* Left side */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "14px",
                        }}
                      >
                        <div
                          style={{
                            width: "56px",
                            height: "56px",
                            backgroundColor: "#F8F8F8",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <ProjectIcs />
                        </div>
                        <div>
                          <div className="fs-16 fw-500 textcolor">
                            {project.project_name ?? "-"}
                          </div>
                          <div>
                            <span className="fs-12_5 fw-500 cardTextGrey">
                              ID :
                            </span>{" "}
                            <span className="fs-13 fw-700 cardTextBlue">
                              {" "}
                              {project.project_code ?? "-"}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Stats */}
                      <div style={{ display: "flex", gap: "12px" }}>
                        {[
                          {
                            title: "Overall",
                            value: numberFormat(project?.total_amount ?? "0"),
                          },

                          {
                            title: "Spent",
                            value: numberFormat(project?.paid_amount ?? "0"),
                          },
                          {
                            title: "Balance to pay",
                            value: numberFormat(project?.balance_amount ?? "0"),
                          },
                        ].map((item, index) => (
                          <div
                            key={index}
                            style={{
                              backgroundColor: "#F8F8F8",
                              padding: "10px 16px",
                              borderRadius: "12px",
                              minWidth: "120px",
                            }}
                          >
                            <div className="fs-12 fw-600 cardTextGrey">
                              {item.title}
                            </div>
                            <div className="fs-14 fw-600 textcolor">
                              ₹ {item.value}
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* Arrow Toggle */}
                      <div
                        style={{
                          width: "40px",
                          height: "64px",
                          borderRadius: "100px",
                          border:
                            expanded === index
                              ? "1px solid #4F46E5"
                              : "1px solid #EBEBEB",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          if (expanded === index) {
                            setExpanded(-1);
                          } else {
                            getProductList(project?.id);
                            setExpanded(index);
                          }
                        }}
                      >
                        {expanded === index ? (
                          <DownArrowClIc />
                        ) : (
                          <DwownArrowIc />
                        )}
                      </div>
                    </div>

                    {/* Expandable Section */}
                    {expanded === index && (
                      <>
                        <div
                          style={{
                            width: "96%",
                            height: 0.5,
                            backgroundColor: "#EBEBEB",
                            marginLeft: "20px",
                            marginRight: "20px",
                            marginBottom: "10px",
                          }}
                        ></div>
                        <div
                          className="fs-12_5 fw-600 textGrey"
                          style={{
                            padding: "0 20px 6px",
                          }}
                        >
                          PRODUCTS :{productsList.length}
                        </div>

                        <table
                          style={{
                            width: "96%",
                            borderCollapse: "collapse",
                            marginLeft: "16px",
                            marginRight: "16px",
                          }}
                        >
                          <thead>
                            <tr
                              style={{
                                backgroundColor: "#F2F2F2",
                                height: "40px",
                              }}
                            >
                              {[
                                "Product Code",
                                "Product Name",

                                "Overall",

                                "Spent",
                                "Balance to Pay",
                              ].map((header, index, array) => (
                                <th
                                  key={index}
                                  className="fs-13 textcolor fw-600"
                                  style={{
                                    padding: "10px 20px",
                                    textAlign: "left",
                                    borderTopLeftRadius:
                                      index === 0 ? "12px" : "",
                                    borderBottomLeftRadius:
                                      index === 0 ? "12px" : "",
                                    borderTopRightRadius:
                                      index === array.length - 1 ? "12px" : "",
                                    borderBottomRightRadius:
                                      index === array.length - 1 ? "12px" : "",
                                    overflow: "hidden",
                                  }}
                                >
                                  {header}
                                </th>
                              ))}
                            </tr>
                          </thead>

                          <tbody style={{ backgroundColor: "#FFFFFF" }}>
                            {productsList.map((row, idx) => (
                              <tr
                                key={idx}
                                className="fs-13 textcolor fw-500"
                                style={{
                                  borderBottom: "1px solid #E5E8EB",
                                  height: "40px",
                                  backgroundColor: "#FFFFFF",
                                  cursor: "pointer",
                                }}
                              >
                                <td
                                  style={{
                                    padding: "10px 20px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <span>{row.item_code}</span>
                                </td>
                                <td style={{ padding: "10px 20px" }}>
                                  {row.item_name}
                                </td>
                                <td style={{ padding: "10px 20px" }}>
                                  ₹ {numberFormat(row.total_amount)}
                                </td>

                                <td style={{ padding: "10px 20px" }}>
                                  ₹ {numberFormat(row.paid_amount)}
                                </td>
                                <td style={{ padding: "10px 20px" }}>
                                  ₹ {numberFormat(row.balance_amount)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <ToastContainer position="top-end">
          <Toast
            className="d-inline-block m-1"
            bg={snackbarStatus === true ? "success" : "danger"}
            show={showSnackbar}
            onClose={handleSnackbarClose}
            delay={3000}
            autohide
          >
            <Toast.Body style={{ color: "#ffffff" }}>
              {snackbarMessage}
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </>
  );
}

export default VendorViewPage;
